export enum ErrorType {
  EMAIL = 'EMAIL',
  GUIDES = 'GUIDES',
  DOWNLOAD_GUIDE = 'DOWNLOAD_GUIDE',
  SUBSCRIPTION = 'SUBSCRIPTION',
}
